export { default as Header } from './Header'
export { default as Footer } from './Footer'
export { default as FloatingServiceMenu } from './FloatingServiceMenu'
export { default as Page, pickSeoProps } from './Page'
export { default as PageTransition } from './PageTransition'
export { default as PageHeader } from './PageHeader'
export { default as PageHero } from './PageHero'
